const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      slider: '.js-slider',
      prev: '.js-slider-btn-prev',
      next: '.js-slider-btn-next',
      videoDynamic: '.js-dynamic-video',
      video: '.js-slider-video',
      activeSlide: '.slick-active',
      image: '.b-slider__slide-image',
      hasZoomEffect: '.has-zoom-effect',
      scalingImage: '.is-scaling',
      play: '.js-btn-play',
      navigation: '.b-slider__pagination',
      dotsContainer: '.js-slider-pagination',
      navContainer: '.js-slider-navigation',
    };

    this.classes = {
      scaling: 'is-scaling',
      hasZoomEffect: 'has-zoom-effect',
      dots: 'b-slider__dots',
      paused: 'is-paused',
      hidden: 'u-hidden',
    };

    this.$sliders = $(this.selectors.slider);

    document.addEventListener('DOMContentLoaded', () => {
      this.initSliders();
      this.sliderNavHandler();
    });
  }

  initDynamicVideo($context = null) {
    const videos = $context
      ? $context.find(this.selectors.videoDynamic)
      : $(this.selectors.videoDynamic);

    if (!videos.length) {
      return;
    }

    videos.each((index, item) => {
      const $video = $(item);
      const $videoElement = $('<video />');

      $.each($video[0].attributes, (i, attr) => {
        $videoElement.attr(attr.name, attr.value);
      });

      const source = $video.attr('data-source-src');
      const mime = $video.attr('data-source-mime');

      $videoElement.append(`<source src="${source}" type="${mime}">`);
      $video.after($videoElement);
      $video.remove();

      // Check if this video is in the active slide and should autoplay
      if ($videoElement.closest('.slick-active').length) {
        if ($videoElement.attr('data-autoplay') === 'yes') {
          $videoElement.prop('muted', true);
          $videoElement[0].play().catch(() => {});
        }
      }
    });
  }

  sliderNavHandler() {
    const navs = $(this.selectors.navContainer);

    if (!navs.length) {
      return;
    }

    navs.each((index, nav) => {
      const $nav = $(nav);
      const playPause = $nav.find(this.selectors.play);

      if (playPause.length) {
        let isPlaying = true;
        const slider = $nav.parent().find(this.selectors.slider);

        if (slider.length) {
          playPause.on('click', () => {
            if (isPlaying) {
              slider.slick('slickPause');
              $nav.addClass(this.classes.paused);
            } else {
              slider.slick('slickPlay');
              $nav.removeClass(this.classes.paused);
            }
            isPlaying = !isPlaying;
          });
        }
      }
    });
  }

  initSliders() {
    if (!this.$sliders.length) {
      return;
    }

    this.$sliders.each((index, item) => {
      const $slider = $(item);
      const dotsContainer = $slider.parent().find(this.selectors.dotsContainer);
      const prevArrow = $slider.parent().find(this.selectors.prev);
      const nextArrow = $slider.parent().find(this.selectors.next);
      const navContainer = $slider.parent().find(this.selectors.navContainer);

      $slider.on('init', () => {
        this.initDynamicVideo($slider);
        this.autoplayActiveSlideVideo($slider);
        this.triggerZoomEffect($slider);
      });

      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        dots: true,
        dotsClass: this.classes.dots,
        prevArrow,
        nextArrow,
        appendDots: dotsContainer,
        adaptiveHeight: true,
      });

      let debounce;
      $slider.on('setPosition', () => {
        clearTimeout(debounce);

        debounce = setTimeout(() => {
          const hasDots = dotsContainer.children().length;
          navContainer.toggleClass(this.classes.hidden, !hasDots);
        }, 500);
      });

      $slider.on('beforeChange', () => {
        const videos = $slider.find(this.selectors.video);
        const scalingImages = $slider.find(this.selectors.scalingImage);

        if (videos.length) {
          $.each(videos, (i, v) => {
            if (!v.paused) {
              v.pause();
            }
          });
        }

        if (scalingImages.length) {
          scalingImages.removeClass(this.classes.scaling);
        }
      });

      $slider.on('afterChange', () => {
        this.autoplayActiveSlideVideo($slider);
        this.triggerZoomEffect($slider);
      });
    });
  }

  autoplayActiveSlideVideo(slider) {
    const video = slider.find(
      `${this.selectors.activeSlide} ${this.selectors.video}`,
    );

    if (video.length) {
      const hasAutoplay = video.attr('data-autoplay') || 'no';

      if (hasAutoplay === 'yes' && video[0].paused) {
        video[0].play().catch(() => {});
      }
    }
  }

  triggerZoomEffect(slider) {
    const activeSlide = slider.find(this.selectors.activeSlide);

    if (
      activeSlide.length &&
      activeSlide.hasClass(this.classes.hasZoomEffect)
    ) {
      const image = activeSlide.find(this.selectors.image);

      if (image.length) {
        image.addClass(this.classes.scaling);
      }
    }
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/slider.js